import { dispatchSearchBoxSuggestionsEvent } from '@coveo/atomic'
import { Component, h, Element, State, Prop } from '@stencil/core'
import { encodeForDomAttribute } from '../../helpers/general-helpers';

/*
  This component adds a title to the Instant Results component (right panel)
  inside the search box OOTB Atomic component.
  - It accepts a `title` prop as a string.
  - The styling needs to be added to the global stylesheet probably. You can use
    this css as an starting point:
      atomic-search-box::part(instant-title) {
        pointer-events: none;
        cursor: unset;
        font-weight: bold;
        text-align: left;
        display: block;
        font-size: 18px;
        padding: 20px;
      }
*/

@Component({
  tag: 'search-box-instant-results-title',
  styleUrl: 'search-box-instant-results-title.css',
  shadow: true,
})
export class SearchBoxInstantResultsTitle {
  @Element() private host!: HTMLElement
  @Prop() public label: string = 'Instant results title';
  @Prop() public panel: 'left' | 'right' = 'right'
  @State() public error!: Error

  connectedCallback() {
    try {
      if (!this.label) return

      dispatchSearchBoxSuggestionsEvent(() => {
        this.label || 'Instant results title'
        const titleEl = document.createElement('h4')
        titleEl.innerText = this.label
        titleEl.classList.add('instant-title')
        titleEl.classList.add("font-bold");

        return {
          position: Array.from(this.host.parentNode!.children).indexOf(this.host),
          panel: this.panel,
          renderItems: () => [
            {
              key: `section-title-${encodeForDomAttribute(this.label)}`,
              part: 'instant-title',
              content: titleEl,
              ariaLabel: this.label,
              hideIfLast: true,
            },
          ]
        }
      }, this.host)
    } catch (error) {
      this.error = error as Error
    }
  }

  render() {
    if (this.error) {
      return (
        <atomic-component-error
          element={this.host}
          error={this.error}
        ></atomic-component-error>
      )
    }
  }
}